// src/components/layout/AppLayout.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import StickyNotesPanel from '../sticky/StickyNotesPanel';
import { notifAPI } from '../../services/api';
import { Bell, Menu } from 'lucide-react';

function getStickyCount(userId) {
  try {
    const notes = JSON.parse(localStorage.getItem(`snp_notes_${userId}`) || '[]');
    return notes.length;
  } catch { return 0; }
}

export default function AppLayout() {
  const { user } = useAuth();
  const navigate  = useNavigate();
  const [unreadCount,   setUnreadCount]   = useState(0);
  const [stickyOpen,    setStickyOpen]    = useState(false);
  const [stickyCount,   setStickyCount]   = useState(0);
  const [sidebarOpen,   setSidebarOpen]   = useState(false); // mobile drawer

  useEffect(() => {
    const fetchNotif = async () => {
      try {
        const res = await notifAPI.unreadCount();
        setUnreadCount(res.data?.count ?? 0);
      } catch {}
    };
    fetchNotif();
    const iv = setInterval(fetchNotif, 30000);
    return () => clearInterval(iv);
  }, []);

  useEffect(() => {
    if (user?.id) setStickyCount(getStickyCount(user.id));
  }, [user?.id, stickyOpen]);

  // Fermer sidebar si on clique en dehors (overlay)
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);

  const handleToggleSticky = useCallback(() => setStickyOpen((o) => !o), []);
  const handleCloseSticky  = useCallback(() => {
    setStickyOpen(false);
    if (user?.id) setStickyCount(getStickyCount(user.id));
  }, [user?.id]);

  return (
    <div className="app-shell">

      {/* ── Mobile topbar (visible < 768px uniquement) ── */}
      <header className="mobile-topbar">
        <button
          className="mobile-topbar__menu"
          onClick={() => setSidebarOpen(o => !o)}
          aria-label="Menu"
        >
          <Menu size={22}/>
        </button>

        <div className="mobile-topbar__brand">
          <div className="mobile-topbar__bars">
            <span className="mobile-topbar__bar" />
            <span className="mobile-topbar__bar" />
            <span className="mobile-topbar__bar" />
          </div>
          <span className="mobile-topbar__name">WIBusiness</span>
        </div>

        <button
          className="mobile-topbar__notif"
          onClick={() => navigate('/notifications')}
          aria-label="Notifications"
        >
          <Bell size={20}/>
          {unreadCount > 0 && (
            <span className="mobile-topbar__badge">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
      </header>

      {/* ── Overlay mobile (ferme la sidebar) ── */}
      {sidebarOpen && (
        <div className="sidebar-mobile-overlay" onClick={closeSidebar}/>
      )}

      <Sidebar
        unreadCount={unreadCount}
        onToggleStickyNotes={handleToggleSticky}
        stickyNotesOpen={stickyOpen}
        stickyNotesCount={stickyCount}
        mobileOpen={sidebarOpen}
        onCloseMobile={closeSidebar}
      />

      <div className="main-content">
        <div className="page-content">
          <Outlet context={{ refreshNotif: () => {} }} />
        </div>
      </div>

      <StickyNotesPanel isOpen={stickyOpen} onClose={handleCloseSticky} />
    </div>
  );
}
